import { cn } from '@/lib/utils';

export type StatusTone = 'success' | 'warning' | 'error' | 'critical' | 'info' | 'neutral';

interface StatusDotProps {
  tone: StatusTone;
  className?: string;
  /** Optional aria-label so screen readers announce the status. */
  label?: string;
}

const toneClass: Record<StatusTone, string> = {
  success: 'bg-efs-success',
  warning: 'bg-efs-warning',
  error: 'bg-efs-error',
  critical: 'bg-efs-critical',
  info: 'bg-efs-info',
  neutral: 'bg-efs-text-muted',
};

export const StatusDot = ({ tone, className, label }: StatusDotProps) => {
  return (
    <span
      aria-label={label}
      role={label ? 'img' : undefined}
      className={cn('inline-block h-2 w-2 rounded-full', toneClass[tone], className)}
    />
  );
};
